export default __webpack_public_path__ + "static/media/Cakery-Loading.409d9d9e.gif";